
import { MiniGameConfig } from "../MiniGame";

// Game configurations
export const miniGames: MiniGameConfig[] = [
  {
    id: "memory-match",
    name: "Memory Match",
    title: "Memory Match",
    instructions: "Match pairs of cards with the same image.",
    difficulty: "Easy",
    gameType: "memory",
    description: "Match pairs of cards with the same image."
  },
  {
    id: "quick-math",
    name: "Quick Math",
    title: "Quick Math",
    instructions: "Solve math problems before time runs out.",
    difficulty: "Medium",
    gameType: "math",
    description: "Solve math problems before time runs out."
  },
  {
    id: "word-scramble",
    name: "Word Scramble",
    title: "Word Scramble",
    instructions: "Unscramble letters to form correct words.",
    difficulty: "Medium",
    gameType: "word",
    description: "Unscramble letters to form correct words."
  }
];
